export const projects = [
  {
    title: "Kranko Jobs",
    subtitle: "Nextjs,Strapi,Stripe,Sendgrid,Apollo Client",
    description:
      "Kranko jobs is a platform that links job seekers with clients. Job seekers can book meetings with clients, get payments and get hired in various projects.Clients can see the various professionals and hire them for their various jobs. Clients can also buy softwares from the platform",
    image: "./kranko-herosection.png",
    link: "https://frontend-krankojobs.vercel.app/",
  },
  {
    title: "Global Green visa",
    subtitle: "Nextjs, strapijs,React,Stripe,TailwindCss",
    description:
      "This project to leverage on tourism bonds with environment conservation. Its a web application, with a visa application process, user dashboard and management dashboard",
    image: "./GGV-web.png",
    link: "https://ggv-pied.vercel.app/",
  },
  {
    title: "MovieHouse",
    subtitle: "Javascript, HTML5,CSS3,API's,JEST",
    description:
      "This projects allows entertainment lovers to comment and vote on the movies and series like",
    image: "./movieapp.png",
    link: "https://javascriptcapstone.vercel.app/",
  },
  {
    title: "School Admission System",
    subtitle: "Java",
    description: "Curated and implemented a school enrollment system",
    image: "./alu.jfif",
    link: "https://github.com/Samuelwanza/school-enrolment-system",
  },
  {
    title: "Space Travellers",
    subtitle: "React, Redux, API's",
    description:
      "This projects allows space travellers, to book rockets, add rockets and remove rockets as well as become members of mission",
    image: "./spacetravellers.png",
    link: "https://reactgroupproject.vercel.app/",
  },
];
export const testimonials = [
  {
    quote:
      "Samuel contributed immensely in the development of web application. He is hardworking, flexible and easy to work with. He is open minded and ready to gauge the viability of ideas and suggestions when presented to him",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Bhalin Singh",
    company: "Global Green Visa",
  },
  {
    quote:
      "Samuel is a great asset to our team. He contributed immensely with innovative ideas on how to improve the project. He is out going and easy to work. Once he sets his mind on something he completes it.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Peter Jipp",
    company: "Global Green Visa",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "Next.js",
  "Node",
  "GraphQL",
  "Strapi.js",
  "Python",
  "Java",
  "Tailwind css",
  "SQL",
  "MongoDb",
  "postgres",
];
